import * as React from "react";

function SvgComponent(
  props: React.SVGProps<SVGSVGElement> & { color?: string }
) {
  const { height = 24, width = 24, color = "#E7212B" } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="8" cy="8" r="8" fill={color} />
      <path d="M11 8L6.5 10.8868L6.5 5.11325L11 8Z" fill="white" />
    </svg>
  );
}

export default SvgComponent;
